import { render, staticRenderFns } from "./UnderwayOrder.vue?vue&type=template&id=3944213d&scoped=true"
import script from "./UnderwayOrder.vue?vue&type=script&lang=js"
export * from "./UnderwayOrder.vue?vue&type=script&lang=js"
import style0 from "./UnderwayOrder.vue?vue&type=style&index=0&id=3944213d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3944213d",
  null
  
)

export default component.exports